import ListingAnaliticsCard from './ListingAnaliticsCard.component';

export default ListingAnaliticsCard;
